import React from "react";
import { Box, Container, Flex, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { Smartphone } from "lucide-react";
import { AppStoreLinks } from "../AppStoreLinks/AppStoreLinks";

const MotionBox = motion(Box);

export const DownloadApp = () => (
  <Box
    id="download-app"
    bg="#E9FFFF"
    py={{ base: "72px", md: "96px" }}
    position="relative"
    overflow="hidden"
  >
    <Box
      position="absolute"
      top="-180px"
      right="-120px"
      w="420px"
      h="420px"
      borderRadius="50%"
      border="64px solid rgba(0,149,200,0.08)"
      pointerEvents="none"
    />
    <Container maxW="1200px" px={{ base: "5", md: "8" }} position="relative">
      <MotionBox
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.55 }}
      >
        <Flex
          direction={{ base: "column", lg: "row" }}
          align={{ base: "center", lg: "center" }}
          justify="space-between"
          gap={{ base: 8, lg: 14 }}
          p={{ base: 7, md: 10 }}
          bg="white"
          borderRadius="16px"
          border="1px solid rgba(0,149,200,0.14)"
          boxShadow="0 16px 48px rgba(41,52,82,0.1)"
        >
          <Flex
            direction={{ base: "column", sm: "row" }}
            align={{ base: "center", sm: "flex-start" }}
            textAlign={{ base: "center", sm: "left" }}
            gap={5}
            maxW="620px"
          >
            <Flex
              w="56px"
              h="56px"
              borderRadius="14px"
              align="center"
              justify="center"
              flexShrink={0}
              bg="rgba(0,149,200,0.1)"
              color="#0095C8"
            >
              <Smartphone size={28} strokeWidth={1.8} />
            </Flex>
            <Box>
              <Text
                fontFamily="'Inter', sans-serif"
                fontSize="0.8125rem"
                fontWeight="600"
                letterSpacing="0.1em"
                textTransform="uppercase"
                color="#0095C8"
                mb={2}
              >
                Learn anywhere
              </Text>
              <Text
                as="h2"
                fontFamily="'Public Sans', sans-serif"
                fontWeight="700"
                fontSize={{ base: "1.75rem", md: "2.375rem" }}
                color="#293452"
                lineHeight="1.2"
                mb={3}
              >
                Take 31Gauge with you
              </Text>
              <Text
                fontFamily="'Inter', sans-serif"
                fontSize={{ base: "0.9375rem", md: "1.0625rem" }}
                color="rgba(41,52,82,0.6)"
                lineHeight="1.7"
              >
                Study guides and concept-driven MCQs are now available on iOS and Android.
              </Text>
            </Box>
          </Flex>

          <AppStoreLinks location="download-section" />
        </Flex>
      </MotionBox>
    </Container>
  </Box>
);
